export default function deeperAssign(a, b) {
  try {
    Object.entries(b).forEach(
      ([k, v]) => (a[k] = v && typeof v === 'object' ? deeperAssign((a[k] = a[k] || {}), v) : v)
    );
  } catch (e) {}
  return a;
}